import React from "react";
import "./EstoreSolutions.css";
import interior from "../assets/interior.png";
import exterior from "../assets/exterior.png";
import decorative from "../assets/decorative.png";

const solutions = [
  {
    img: interior,
    title: "Interior Paint Collection",
    description:
      "Transform your living spaces with our premium interior paints, perfect for bedrooms, living rooms, kitchens, and all indoor applications.",
  },
  {
    img: exterior,
    title: "Exterior Paint Range",
    description:
      "Protect and beautify your property’s exterior with our weather-resistant paint formulations designed for Pakistan’s climate.",
  },
  {
    img: decorative,
    title: "Decorative Paint Series",
    description:
      "Add artistic touches and unique finishes to your walls with our specialized decorative paint collection.",
  },
];

function EstoreSolutions() {
  return (
    <section className="estore-solutions">
      <h2 className="estore-solutions-title">Complete Paint Solutions</h2>
      <p className="estore-solutions-subtitle">
        Browse our comprehensive collection of premium paint products:
      </p>

      <div className="estore-solutions-grid">
        {solutions.map((item, index) => (
          <div className="estore-solutions-card" key={index}>
            <img
              src={item.img}
              alt={item.title}
              className="estore-solutions-image"
            />
            <div className="estore-solutions-content">
              <h3 className="estore-solutions-card-title">{item.title}</h3>
              <p className="estore-solutions-card-text">{item.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default EstoreSolutions;
